import React from 'react';
import { motion } from 'framer-motion';
import LoadingSpinner from './LoadingSpinner';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className = '',
  ...props
}) => {
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 font-rubik';
  
  const variants = {
    primary: 'text-white focus:ring-secondary-300 disabled:opacity-60',
    secondary: 'bg-white text-primary-500 border-2 border-primary-500 hover:bg-primary-50 focus:ring-primary-500',
    outline: 'border-2 border-secondary-300 text-primary-500 hover:bg-secondary-300 hover:text-white focus:ring-secondary-300',
    ghost: 'text-primary-500 hover:bg-secondary-100 focus:ring-secondary-300',
    danger: 'bg-red-500 hover:bg-red-600 text-white focus:ring-red-500 disabled:bg-red-300',
    success: 'bg-success-500 hover:bg-success-600 text-white focus:ring-success-500 disabled:bg-success-300'
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-6 py-3 text-base',
    xl: 'px-8 py-4 text-lg'
  };

  const isDisabled = disabled || loading;

  const getButtonStyle = () => {
    if (variant === 'primary') {
      return {
        backgroundColor: '#c8d8e4',
        color: '#ffffff'
      };
    }
    return {};
  };

  const getHoverStyle = () => {
    if (variant === 'primary') {
      return {
        backgroundColor: '#b3c9d7'
      };
    }
    return {};
  };

  return (
    <motion.button
      whileHover={!isDisabled ? { scale: 1.02, ...getHoverStyle() } : {}}
      whileTap={!isDisabled ? { scale: 0.98 } : {}}
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className} ${
        isDisabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
      }`}
      style={getButtonStyle()}
      disabled={isDisabled}
      {...props}
    >
      {loading && <LoadingSpinner size="sm" className="mr-2" />}
      {children}
    </motion.button>
  );
};

export default Button;